import type { FaireProductEntity } from "../../entity_types/product";

export const p_xebpbvxmrw: FaireProductEntity = {
  token: "p_xebpbvxmrw",
  type: "product",
  name: "HALTER NECK LACE TRIM DETAIL SLEEVELESS TOP",
  brandToken: "b_q8gu9by5sv",
  brandName: "LE LIS",
  imageUrl:
    "https://cdn.faire.com/fastly/3671a9e3bb832b5eb4e6c3bd5016f4a659d8dab6d13607a726914466af039466.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/595ca623643ae6b85f24717aee9797a7258c7948d8e745c29aa4806f2104615b.jpeg",
    "https://cdn.faire.com/fastly/1233981c6b5530390ddb88a3dff1e7098a8477f25ec6763603b417cc690b4357.jpeg",
    "https://cdn.faire.com/fastly/834267cb5d4254b9f309fb1939d445deb08789be559b22f62627019f0c98e3d5.jpeg",
    "https://cdn.faire.com/fastly/f5b05a0d99258a8e31aa92cc1538d9756000b1e3486b010813446f3c9a13d73e.jpeg",
    "https://cdn.faire.com/fastly/4db67c7f0cf68f04fd9329fbf8d510399e7cb5c884919b63c8e33b53961fa1d8.jpeg",
    "https://cdn.faire.com/fastly/934c8f49074f39709c5da55163a9c05fde45808f27b5c21cce9232f92b6c2fc2.jpeg",
    "https://cdn.faire.com/fastly/19c53ea1fa63836a25bd01a8e30696c25fff598c5901e3b6ea9d54defb7e10e7.jpeg",
    "https://cdn.faire.com/fastly/2262942c7dec77dfbd9644456cfdc0c90cfefa4addbf95030c48e5dac3a312ea.jpeg",
    "https://cdn.faire.com/fastly/c7c88165e41ee0ec17b5506dc5b8c8497b5cf9f3ca35b4305f835cb18bfa25f2.jpeg",
    "https://cdn.faire.com/fastly/37b9ff843f5d232e191e51c9c1340a2586b02fd3e5a1cbf80a5c6fdafcc42716.jpeg",
    "https://cdn.faire.com/fastly/f5a251f7a64c70eed5889c9a63d770384a47e2d8bd1ad383d14b2dffd7e2070b.jpeg",
    "https://cdn.faire.com/fastly/da927d815c280e67baa394675603c5310777fafaec6f8cf6f7a31815302528c9.jpeg",
    "https://cdn.faire.com/fastly/1ac3bafaa842143a9d606dba5fb4e37ffa986fec4ce9c0c3d43e2dbaa4f9110c.jpeg",
    "https://cdn.faire.com/fastly/df64e71fe86fb80bc32ec1071354cb29442c856d8b72afb0677801c90403a737.jpeg",
    "https://cdn.faire.com/fastly/ab7e4cc5c33a195c0a91ae465238a4e0fe8814a45e938b423c126f05022a84ab.jpeg",
    "https://cdn.faire.com/fastly/a113af9166c704f4cc3443d512b4c8ff181d72d3033a07c7316262d65d1eb561.jpeg",
    "https://cdn.faire.com/fastly/990d945707cf876eac725f13fc001ab0c8f829f6b7d777ca2f6f43c477886b29.jpeg",
    "https://cdn.faire.com/fastly/1e61ba10c965e08597231a2a81c05323c7aa02ac96d6014ecd19483771bf1157.jpeg",
    "https://cdn.faire.com/fastly/6924ea53d01b60cb01e14f2a9ab6b508f902056abe15a22e1f4ad3ddff275bc8.jpeg",
    "https://cdn.faire.com/fastly/db516ccbb2b0dccacb368035d9b4e7580000bfe52b566a23dcbc7b27bdf12a59.jpeg",
  ],
  priceDollars: 162,
  description:
    '**TOP ONLY**\n\n(MATCHING SET WITH: SP3823)\n\nMODEL IS WEARING A SIZE SMALL\n\nMODEL SPECS\nHEIGHT: 5\'8"\nBUST: 32A\nWAIST: 24"\nHIPS: 34"',
  tags: [],
  msrpDollars: 324,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:52:07.139Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
